import { useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { toast } from 'sonner';
import { Heart, DollarSign } from 'lucide-react';

const PRESET_AMOUNTS = [5, 10, 20, 50];

const DonationCard = () => {
  const [amount, setAmount] = useState(5);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (amount < 1) {
      toast.error('Minimum donation is $1');
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('/payment/donation', {
        amount: parseFloat(amount),
        origin_url: window.location.origin
      });
      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create donation');
      setLoading(false);
    }
  };

  return (
    <Card className="card-surface border-[#27272A]" data-testid="donation-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
          <Heart className="w-5 h-5 text-[#8B5CF6]" />Make a Donation
        </CardTitle>
        <CardDescription>Support mental health initiatives</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="bg-[#27272A] border border-[#8B5CF6] rounded-lg p-4">
          <p className="text-sm text-[#A1A1AA]"><strong className="text-[#F9FAFB]">50/50 Split:</strong> Your donation is split equally between:</p>
          <ul className="mt-2 space-y-1 text-sm text-[#A1A1AA] ml-4">
            <li>Developer (for app maintenance)</li>
            <li>Mental Health Canada (charity)</li>
          </ul>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="donationAmount" className="text-[#F9FAFB]"><DollarSign className="w-4 h-4 inline mr-1" />Donation Amount</Label>
            <Input id="donationAmount" type="number" min="1" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="bg-[#0A0A0A] border-[#27272A] focus:ring-[#8B5CF6] text-lg" data-testid="donation-amount-input" />
          </div>
          <div className="grid grid-cols-4 gap-2">
            {PRESET_AMOUNTS.map((preset) => (
              <button key={preset} type="button" onClick={() => setAmount(preset)} className="px-3 py-2 rounded-lg border border-[#27272A] hover:border-[#8B5CF6] hover:bg-[#1E1E1E] transition-all duration-300 text-sm" data-testid={`preset-${preset}`}>${preset}</button>
            ))}
          </div>
          <Button type="submit" disabled={loading} className="btn-purple w-full rounded-full py-6 text-base font-semibold" data-testid="submit-donation-button">
            {loading ? 'Redirecting to checkout...' : `Donate $${amount}`}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default DonationCard;
